/* O que o e-mail da TT Fixa precisa (Douglas 24/10/2026): o Contrato PF da fibra
   e o endereço completo, na régua do backend (tt-fixa-gerente.service): CEP,
   logradouro, número, cidade e UF. */

export type EnderecoTt = { cep?: string; logradouro?: string; numero?: string; complemento?: string; bairro?: string; cidade?: string; uf?: string };
export type DadosTt = { contratoPf: string; endereco: EnderecoTt };

export const enderecoTtCompleto = (e: EnderecoTt | null | undefined) =>
  !!(e?.cep?.trim() && e.logradouro?.trim() && e.numero?.trim() && e.cidade?.trim() && e.uf?.trim());

/** O que falta para o e-mail sair, para a linha e para o botão. */
export function faltaParaEmailTt(d: DadosTt | undefined): string[] {
  const falta: string[] = [];
  if (!d?.contratoPf?.trim()) falta.push('contrato PF');
  if (!enderecoTtCompleto(d?.endereco)) falta.push('endereço');
  return falta;
}
